<mat-spinner *ngIf="!_ready" diameter="50" />
<div *ngIf="_error">Error retrieving report.</div>
<div class="responsive-iframe">
  <iframe
    *ngIf="_ready && !_error"
    [title]="title"
    [src]="_url | safe"
    frameborder="0"
    allowFullScreen="true"
  ></iframe>
</div>
